import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import Header from './header';
import Footer from './footer';
import ToTop from './to-top';

import './index.css';

const Layout = ({ className, children, ...other }) => {
	const contentRef = useRef(null);

	const onSkipContentClick = () => contentRef.current.focus();

	return (
		<section className='cws-layout grid h-full grid-cols-1 grid-rows-[auto_1fr_auto]'>
			<a
				href='#content'
				className='skipLink sr-only focus:not-sr-only focus:!absolute focus:left-1 focus:top-1 focus:z-30 focus:bg-white focus:px-4 focus:py-2'
				onClick={onSkipContentClick}
			>
				Skip to Content
			</a>

			<Header />

			<main
				id='content'
				ref={contentRef}
				{...other}
			>
				{children}

				<ToTop />
			</main>

			<Footer />
		</section>
	);
};

Layout.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};

export default Layout;
